export default from './Profile';



// WEBPACK FOOTER //
// ./src/containers/Profile/index.js